'use strict'

import HttpClient from './HttpClient'

class Doc extends HttpClient {
  urls = {}
  constructor (type = '', refId = '') {
    super()
    if (refId) {
      refId = '/' + refId
    }
    const apiUrl = {
      companyLogo: {
        getOne: '/api/admin/get/latest/company/profile/logo/img' + refId,
        img: '/api/admin/upload/company/profile/logo/img' + refId,
        delete: '/api/admin/delete/company/profile/logo/img'
      },
      companyProfile: {
        all: '/api/admin/get/one/company/profile/doc/list' + refId,
        img: '/api/admin/upload/company/profile/doc/img' + refId,
        pdf: '/api/admin/upload/company/profile/doc/pdf' + refId,
        delete: '/api/admin/delete/one/company/profile/doc',
        getPdf: '/api/admin/download/one/company/profile/doc/pdf'
      },
      companyShowcase: {
        all: '/api/admin/get/one/company/profile/showcase/doc/list' + refId,
        img: '/api/admin/upload/company/profile/showcase/doc/img' + refId,
        pdf: '/api/admin/upload/company/profile/showcase/doc/pdf' + refId,
        delete: '/api/admin/delete/one/company/profile/showcase/doc',
        getPdf: '/api/admin/download/one/company/profile/showcase/doc/pdf'
      }
    }
    switch (type) {
      case 'company-logo':
        this.urls = apiUrl.companyLogo
        break
      case 'company-profile':
        this.urls = apiUrl.companyProfile
        break
      case 'company-showcase':
        this.urls = apiUrl.companyShowcase
        break
      default:
        alert('ระบุเอกสารผิดพลาด')
    }
  }
  deleteDoc (docId) {
    var url = this.urls.delete

    var data = {
      docId: docId
    }

    return this.sendDelete(url, this.headers, data)
  }
  getUrlImg () {
    return process.env.VUE_APP_LOGISTY_API_HOST_NAME + this.urls.img
  }
  getUrlPdf () {
    return process.env.VUE_APP_LOGISTY_API_HOST_NAME + this.urls.pdf
  }
  getAllDoc () {
    var url = this.urls.all
    return this.sendGet(url, this.headers)
  }
  getPdfDoc (docId) {
    var url = this.urls.getPdf + '/' + docId
    return this.sendGetPdf(url, this.headers)
  }
  getOneLogo () {
    var url = this.urls.getOne
    return this.sendGet(url, this.headers)
  }
}

export default Doc
